import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import Navbar from "../components/Navbar";
import Footer from "../Footer";
import axios from "axios";
import { Bounce, ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { BtnLoader } from "../components/PageLoader";

const DealerRegistration = () => {
  const navigator = useNavigate();
  const optionToast = {
    position: "top-right",
    autoClose: 3000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: "colored",
    transition: Bounce,
  };
  const [processing, setProcessing] = useState(false);
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [website, setWebsite] = useState("");
  const [dealershipName, setDealershipName] = useState("");
  const [dealershipAddress, setDealershipAddress] = useState("");
  const [addressFirst, setAddressFirst] = useState("");
  const [addressSecond, setAddressSecond] = useState("");
  const [city, setCity] = useState("");
  const [country, setCountry] = useState("");
  const [postCode, setPostCode] = useState("");
  const [dealershipId, setDealershipId] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [showPasswordConfirm, setShowPasswordConfirm] = useState(false);
  const [showOtpInput, setShowOtpInput] = useState(false);
  const [otp, setOtp] = useState("");
  const [userOTP, setUserOtp] = useState("");
  const [phoneValidation, setValidationMessage] = useState("");
  const [messageColor, setMessageColor] = useState("");
  const [errors, setErrors] = useState({});
  const [otpCountdown, setOtpCountdown] = useState(0); // Countdown in seconds
  const [canResendOtp, setCanResendOtp] = useState(false);

  const phoneNumberRegex = /^\+?[0-9]{1,15}$/;

  // Countdown timer effect
  useEffect(() => {
    let timer;
    if (otpCountdown > 0) {
      timer = setInterval(() => {
        setOtpCountdown((prev) => prev - 1);
      }, 1000);
    } else if (otpCountdown === 0 && showOtpInput) {
      setCanResendOtp(true);
    }
    return () => clearInterval(timer);
  }, [otpCountdown, showOtpInput]);

  const formatTime = (seconds) => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
  };

  const validatePhoneNumber = (number) => {
    if (phoneNumberRegex.test(number)) {
      if (number.length >= 10 && number.length <= 15) {
        setValidationMessage("Valid phone number");
        setMessageColor("green");
      } else {
        setValidationMessage("Phone number must be between 10 and 15 digits.");
        setMessageColor("red");
      }
    } else {
      setValidationMessage(
        'Invalid phone number. Only numeric characters and an optional leading "+" are allowed.'
      );
      setMessageColor("red");
    }
  };

  const handlePhoneNumber = (e) => {
    const { value } = e.target;
    if (/^\+?[0-9]*$/.test(value)) {
      setPhone(value);
      validatePhoneNumber(value);
    }
  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const togglePasswordVisibilityConfirm = () => {
    setShowPasswordConfirm(!showPasswordConfirm);
  };

  const validate = () => {
    const newErrors = {};

    if (!firstName.match(/^[A-Za-z]+$/)) {
      newErrors.firstName = "First name must contain only letters";
    }

    if (!email.match(/^\S+@\S+\.\S+$/)) {
      newErrors.email = "Enter a valid email address";
    }

    const cleanedPhone = phone.replace(/[^\d]/g, '');
    if (!cleanedPhone.match(/^\d{10,15}$/)) {
      newErrors.phone = "Enter a valid phone number (10 to 15 digits)";
    }

    if (website && !website.match(/^(https?:\/\/)?([\w\d\-_]+\.+\S{2,})+$/)) {
      newErrors.website = "Enter a valid website URL";
    }

    if (!dealershipName) {
      newErrors.dealershipName = "Dealership name is required";
    }

    if (!addressFirst) {
      newErrors.addressFirst = "Address Line 1 is required";
    }

    if (!city.match(/^[A-Za-z\s]+$/)) {
      newErrors.city = "City must contain only letters";
    }

    if (!country.match(/^[A-Za-z\s]+$/)) {
      newErrors.country = "Country must contain only letters";
    }

    if (!postCode.match(/^[\w\s\-+]{3,12}$/i)) {
      newErrors.postCode = "Enter a valid post code";
    }

    if (!password) {
      newErrors.password = "Password is required";
    } else if (password !== confirmPassword) {
      newErrors.confirmPassword = "Passwords do not match";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSignUp = () => {
    setProcessing(true);
    var isValidate = validate();
    if (!isValidate) {
      toast.error("Please fix all validation errors", optionToast);
      setProcessing(false);
      return;
    }

    if (password !== confirmPassword) {
      toast.error(
        "Password does not match the confirmation password",
        optionToast
      );
      setProcessing(false);
      return;
    }

    if (!showOtpInput) {
      sendOtpData();
    } else {
      if (userOTP === parseInt(otp)) {
        saveData();
      } else {
        setProcessing(false);
        toast.error("Invalid OTP", optionToast);
      }
    }
  };

  const sendOtpData = async () => {
    setProcessing(true);
    try {
      const response = await axios.post(
        window.CARLOCA_API + "/user/email/verify",
        {
          email: email,
        }
      );
      if (response?.data?.status) {
        setUserOtp(response?.data?.otp);
        setShowOtpInput(true);
        setOtpCountdown(180); // Reset to 3 minutes
        setCanResendOtp(false);
        toast.success(response?.data?.message, optionToast);
      } else {
        toast.error(response?.data?.message, optionToast);
      }
    } catch (error) {
      console.log("An error occurred while fetching data.", error);
      toast.error("Failed to send OTP. Please try again.", optionToast);
    }
    setProcessing(false);
  };
  const saveDataTolocalStorage = (key, data) => {
    try {
      const serializedData = JSON.stringify(data);
      localStorage.setItem(key, serializedData);
    } catch (error) {
      console.error("Error saving data to localStorage:", error);
    }
  };
  const handleResendOtp = async () => {
    if (!canResendOtp) return;

    setProcessing(true);
    try {
      const response = await axios.post(
        window.CARLOCA_API + "/user/email/verify",
        {
          email: email,
        }
      );
      if (response?.data?.status) {
        setUserOtp(response?.data?.otp);
        setOtpCountdown(180); // Reset to 3 minutes
        setCanResendOtp(false);
        toast.success("OTP resent successfully", optionToast);
      } else {
        toast.error(response?.data?.message, optionToast);
      }
    } catch (error) {
      console.log("An error occurred while fetching data.", error);
      toast.error("Failed to resend OTP. Please try again.", optionToast);
    }
    setProcessing(false);
  };

  const saveData = async () => {
    setProcessing(true);
    try {
      const response = await axios.post(
        window.CARLOCA_API + "/register/dealer",
        {
          email: email,
          password: password,
          first_name: firstName,
          last_name: lastName,
          phone: phone,
          website: website,
          dealershipName: dealershipName,
          dealershipAddress: dealershipAddress,
          addressFirst: addressFirst,
          addressSecond: addressSecond,
          city: city,
          country: country,
          postcode: postCode,
          dealershipId: dealershipId,
        }
      );

      if (response?.data?.status) {
        // Clear all fields
        const newUserData = { ...response?.data?.data };
        if (response?.data?.token) {
          newUserData.token = response?.data?.token;
        }
        saveDataTolocalStorage("userData", newUserData);
        setFirstName("");
        setLastName("");
        setEmail("");
        setPassword("");
        setConfirmPassword("");
        setWebsite("");
        setDealershipName("");
        setPhone("");
        setDealershipAddress("");
        setAddressFirst("");
        setAddressSecond("");
        setCity("");
        setCountry("");
        setPostCode("");
        setValidationMessage("");
        setMessageColor("");
        setDealershipId("");
        setOtp("");
        setShowOtpInput(false);
        setOtpCountdown(0);
        setCanResendOtp(false);

        toast.success(response?.data?.message, optionToast);
        setTimeout(() => {
          navigator("/login");
        }, 1500);
      } else {
        toast.error(response?.data?.message, optionToast);
      }
    } catch (error) {
      console.log("An error occurred while fetching data.", error);
      toast.error("Registration failed. Please try again.", optionToast);
    }
    setProcessing(false);
  };

  return (
    <>
      <Navbar />
      <div className="cl-auth-page" style={{ paddingTop: 78, paddingBottom: 48 }}>
        <div className="cl-auth-card" style={{ maxWidth: 560 }}>

          {/* Logo + header */}
          <div className="text-center mb-3">
            <img src="/img/logo.png" alt="Carloca" style={{ height: 44, marginBottom: 10 }} />
          </div>
          <h5 className="cl-auth-title">Dealer Registration</h5>
          <p className="cl-auth-subtitle">Create your dealer account to start listing cars</p>

          <form onSubmit={(e) => { e.preventDefault(); handleSignUp(); }}>

            {/* Name row */}
            <div className="row g-3 mb-1">
              <div className="col-6">
                <label className="cl-form-label">First Name <span className="text-danger">*</span></label>
                <div className="position-relative">
                  <input type="text" className={`cl-form-control${errors.firstName ? " is-invalid" : ""}`}
                    placeholder="John" style={{ paddingLeft: 36 }}
                    value={firstName} onChange={(e) => setFirstName(e.target.value)} />
                  <i className="fa-regular fa-user" style={{ position: "absolute", left: 11, top: "50%", transform: "translateY(-50%)", color: "#b0bac5", fontSize: 13 }}></i>
                </div>
                {errors.firstName && <small className="text-danger">{errors.firstName}</small>}
              </div>
              <div className="col-6">
                <label className="cl-form-label">Last Name</label>
                <div className="position-relative">
                  <input type="text" className="cl-form-control"
                    placeholder="Doe" style={{ paddingLeft: 36 }}
                    value={lastName} onChange={(e) => setLastName(e.target.value)} />
                  <i className="fa-regular fa-user" style={{ position: "absolute", left: 11, top: "50%", transform: "translateY(-50%)", color: "#b0bac5", fontSize: 13 }}></i>
                </div>
              </div>
            </div>

            {/* Email */}
            <div className="mb-3">
              <label className="cl-form-label">Email Address <span className="text-danger">*</span></label>
              <div className="position-relative">
                <input type="email" className={`cl-form-control${errors.email ? " is-invalid" : ""}`}
                  placeholder="you@email.com" style={{ paddingLeft: 36 }}
                  value={email} onChange={(e) => setEmail(e.target.value)} />
                <i className="fa-regular fa-envelope" style={{ position: "absolute", left: 11, top: "50%", transform: "translateY(-50%)", color: "#b0bac5", fontSize: 13 }}></i>
              </div>
              {errors.email && <small className="text-danger">{errors.email}</small>}
            </div>

            {/* Phone */}
            <div className="mb-3">
              <label className="cl-form-label">Phone Number <span className="text-danger">*</span></label>
              <div className="position-relative">
                <input type="tel" className={`cl-form-control${errors.phone ? " is-invalid" : ""}`}
                  placeholder="+44 7000 000000" style={{ paddingLeft: 36 }}
                  value={phone} onChange={handlePhoneNumber} />
                <i className="fa-solid fa-phone" style={{ position: "absolute", left: 11, top: "50%", transform: "translateY(-50%)", color: "#b0bac5", fontSize: 13 }}></i>
              </div>
              {phoneValidation && <small style={{ color: messageColor }}>{phoneValidation}</small>}
              {errors.phone && <small className="text-danger d-block">{errors.phone}</small>}
            </div>

            {/* Dealership name + website */}
            <div className="row g-3 mb-1">
              <div className="col-sm-7">
                <label className="cl-form-label">Dealership Name <span className="text-danger">*</span></label>
                <div className="position-relative">
                  <input type="text" className={`cl-form-control${errors.dealershipName ? " is-invalid" : ""}`}
                    placeholder="e.g., Premier Cars Ltd" style={{ paddingLeft: 36 }}
                    value={dealershipName} onChange={(e) => setDealershipName(e.target.value)} />
                  <i className="fa-solid fa-store" style={{ position: "absolute", left: 11, top: "50%", transform: "translateY(-50%)", color: "#b0bac5", fontSize: 13 }}></i>
                </div>
                {errors.dealershipName && <small className="text-danger">{errors.dealershipName}</small>}
              </div>
              <div className="col-sm-5">
                <label className="cl-form-label">Dealer ID <span className="text-muted" style={{ fontWeight: 400 }}>(if known)</span></label>
                <div className="position-relative">
                  <input type="text" className="cl-form-control"
                    placeholder="Optional" style={{ paddingLeft: 36 }}
                    value={dealershipId} onChange={(e) => setDealershipId(e.target.value)} />
                  <i className="fa-solid fa-id-card" style={{ position: "absolute", left: 11, top: "50%", transform: "translateY(-50%)", color: "#b0bac5", fontSize: 13 }}></i>
                </div>
              </div>
            </div>

            {/* Website */}
            <div className="mb-3">
              <label className="cl-form-label">Website</label>
              <div className="position-relative">
                <input type="url" className={`cl-form-control${errors.website ? " is-invalid" : ""}`}
                  placeholder="https://yoursite.com" style={{ paddingLeft: 36 }}
                  value={website} onChange={(e) => setWebsite(e.target.value)} />
                <i className="fa-solid fa-globe" style={{ position: "absolute", left: 11, top: "50%", transform: "translateY(-50%)", color: "#b0bac5", fontSize: 13 }}></i>
              </div>
              {errors.website && <small className="text-danger">{errors.website}</small>}
            </div>

            {/* Address section */}
            <p className="mb-2 fw-semibold" style={{ fontSize: 13, color: "#555", borderBottom: "1px solid #e9ecef", paddingBottom: 6 }}>
              <i className="fa-solid fa-location-dot me-1" style={{ color: "#00889c" }}></i>Dealership Address
            </p>
            <div className="mb-3">
              <label className="cl-form-label">Address Line 1 <span className="text-danger">*</span></label>
              <div className="position-relative">
                <input type="text" className={`cl-form-control${errors.addressFirst ? " is-invalid" : ""}`}
                  placeholder="Street address" style={{ paddingLeft: 36 }}
                  value={addressFirst} onChange={(e) => setAddressFirst(e.target.value)} />
                <i className="fa-solid fa-house" style={{ position: "absolute", left: 11, top: "50%", transform: "translateY(-50%)", color: "#b0bac5", fontSize: 13 }}></i>
              </div>
              {errors.addressFirst && <small className="text-danger">{errors.addressFirst}</small>}
            </div>
            <div className="mb-3">
              <label className="cl-form-label">Address Line 2</label>
              <div className="position-relative">
                <input type="text" className="cl-form-control"
                  placeholder="Apartment, suite, etc." style={{ paddingLeft: 36 }}
                  value={addressSecond} onChange={(e) => setAddressSecond(e.target.value)} />
                <i className="fa-solid fa-house" style={{ position: "absolute", left: 11, top: "50%", transform: "translateY(-50%)", color: "#b0bac5", fontSize: 13 }}></i>
              </div>
            </div>
            <div className="row g-3 mb-3">
              <div className="col-sm-4">
                <label className="cl-form-label">City <span className="text-danger">*</span></label>
                <input type="text" className={`cl-form-control${errors.city ? " is-invalid" : ""}`}
                  placeholder="London"
                  value={city} onChange={(e) => setCity(e.target.value)} />
                {errors.city && <small className="text-danger">{errors.city}</small>}
              </div>
              <div className="col-sm-4">
                <label className="cl-form-label">Country <span className="text-danger">*</span></label>
                <input type="text" className={`cl-form-control${errors.country ? " is-invalid" : ""}`}
                  placeholder="United Kingdom"
                  value={country} onChange={(e) => setCountry(e.target.value)} />
                {errors.country && <small className="text-danger">{errors.country}</small>}
              </div>
              <div className="col-sm-4">
                <label className="cl-form-label">Post Code <span className="text-danger">*</span></label>
                <input type="text" className={`cl-form-control${errors.postCode ? " is-invalid" : ""}`}
                  placeholder="SW1A 1AA"
                  value={postCode} onChange={(e) => setPostCode(e.target.value)} />
                {errors.postCode && <small className="text-danger">{errors.postCode}</small>}
              </div>
            </div>

            {/* Password section */}
            <p className="mb-2 fw-semibold" style={{ fontSize: 13, color: "#555", borderBottom: "1px solid #e9ecef", paddingBottom: 6 }}>
              <i className="fa-solid fa-lock me-1" style={{ color: "#00889c" }}></i>Account Security
            </p>
            <div className="row g-3 mb-3">
              <div className="col-sm-6">
                <label className="cl-form-label">Password <span className="text-danger">*</span></label>
                <div className="position-relative">
                  <input type={showPassword ? "text" : "password"}
                    className={`cl-form-control${errors.password ? " is-invalid" : ""}`}
                    placeholder="••••••••" style={{ paddingLeft: 36, paddingRight: 38 }}
                    value={password} onChange={(e) => setPassword(e.target.value)} />
                  <i className="fa-solid fa-lock" style={{ position: "absolute", left: 11, top: "50%", transform: "translateY(-50%)", color: "#b0bac5", fontSize: 13 }}></i>
                  <span onClick={togglePasswordVisibility} style={{ position: "absolute", right: 11, top: "50%", transform: "translateY(-50%)", cursor: "pointer", color: "#b0bac5" }}>
                    <i className={`fa-solid ${showPassword ? "fa-eye-slash" : "fa-eye"}`} style={{ fontSize: 13 }}></i>
                  </span>
                </div>
                {errors.password && <small className="text-danger">{errors.password}</small>}
              </div>
              <div className="col-sm-6">
                <label className="cl-form-label">Confirm Password <span className="text-danger">*</span></label>
                <div className="position-relative">
                  <input type={showPasswordConfirm ? "text" : "password"}
                    className={`cl-form-control${errors.confirmPassword ? " is-invalid" : ""}`}
                    placeholder="••••••••" style={{ paddingLeft: 36, paddingRight: 38 }}
                    value={confirmPassword} onChange={(e) => setConfirmPassword(e.target.value)} />
                  <i className="fa-solid fa-lock" style={{ position: "absolute", left: 11, top: "50%", transform: "translateY(-50%)", color: "#b0bac5", fontSize: 13 }}></i>
                  <span onClick={togglePasswordVisibilityConfirm} style={{ position: "absolute", right: 11, top: "50%", transform: "translateY(-50%)", cursor: "pointer", color: "#b0bac5" }}>
                    <i className={`fa-solid ${showPasswordConfirm ? "fa-eye-slash" : "fa-eye"}`} style={{ fontSize: 13 }}></i>
                  </span>
                </div>
                {errors.confirmPassword && <small className="text-danger">{errors.confirmPassword}</small>}
              </div>
            </div>

            {/* OTP */}
            {showOtpInput && (
              <div className="mb-3">
                <label className="cl-form-label">Verification Code <span className="text-danger">*</span></label>
                <div className="position-relative">
                  <input type="text" className="cl-form-control"
                    placeholder="Enter the OTP sent to your email" style={{ paddingLeft: 36 }}
                    value={otp} onChange={(e) => setOtp(e.target.value)} />
                  <i className="fa-solid fa-key" style={{ position: "absolute", left: 11, top: "50%", transform: "translateY(-50%)", color: "#b0bac5", fontSize: 13 }}></i>
                </div>
                <small className="text-muted d-block mt-1" style={{ fontSize: 12 }}>
                  <i className="fa-solid fa-circle-info me-1"></i>Check your spam/junk folder if you don't receive the email.
                </small>
                <div className="mt-1">
                  {otpCountdown > 0 ? (
                    <small className="text-muted" style={{ fontSize: 12 }}>Resend OTP in {formatTime(otpCountdown)}</small>
                  ) : (
                    <small className="text-decoration-none fw-semibold" style={{ fontSize: 12, color: "#00889c", cursor: "pointer" }} onClick={handleResendOtp}>
                      <i className="fa-solid fa-rotate-right me-1"></i>Resend OTP
                    </small>
                  )}
                </div>
              </div>
            )}

            {/* Submit */}
            <button type="submit" className="cl-btn cl-btn-primary w-100 mt-2" disabled={processing}>
              {processing ? <BtnLoader /> : showOtpInput ? <><i className="fa-solid fa-check me-1"></i>Verify &amp; Register</> : <><i className="fa-solid fa-user-plus me-1"></i>Create Account</>}
            </button>

            <div className="cl-auth-divider">Already have an account?</div>
            <Link to="/login" className="cl-btn cl-btn-outline w-100">
              <i className="fa-solid fa-arrow-right-to-bracket me-1"></i>Sign In
            </Link>
          </form>
        </div>
      </div>
      <Footer />
      <ToastContainer />
    </>
  );
};

export default DealerRegistration;
